import Model from "../Model";

export default class extends Model {
  async loadTable(page, limit, search = '') {
    let response = await super.list(page, limit, search).then(result => {return result});
    let result = {
      tbody: [],
      pages: response.pages,
    };
    if(response.items !== undefined && response.items.length > 0)
    {
      response.items.forEach(sender => {
        let telem = {
          tbody: {}
        };
        telem.id = sender.id;
        telem.tbody.name = sender.name;
        telem.tbody.email = sender.email;
        telem.tbody.header = sender.header;
        telem.tbody.footer = sender.footer;
        result.tbody.push(telem);
      });
    }
    return result;
  }
}
